import { theme } from 'design-cannect'
import styled, { css } from 'styled-components'

export type InputProps = {
  width?: string
}

export type WrapperProps = {
  outlined?: boolean
}

export const ContainerInput = styled('div')<InputProps>`
  ${({ width }) => css`
    width: ${width || 'auto'};
    min-height: 27px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: space-between;
    .wrapper-icon {
      position: absolute;
      transition: transform 0.3s;
      right: 16px;
      top: 10px;
      padding-left: 8px;
      color: black;
    }
  `}
`

export const WrapperInput = styled('input')<WrapperProps>`
  ${({ outlined }) => css`
    border-radius: 28px;
    padding: 0 16px 0 8px;
    border: ${outlined ? `2px solid black` : '1px solid black'};
    min-height: 38px;
    box-shadow: 0 0 0 0.2px inset;
    color: black;
    font-weight: 300;
    width: 100%;

    &:focus {
      outline: none;
      background: white;
      border-color: black;
      box-shadow: 0 0 2px black;
    }

    &:-webkit-autofill {
      background: -internal-light-dark(black, white) !important;
      -webkit-box-shadow: 0 0 0 30px black inset;
      -webkit-text-fill-color: black !important;
    }

    ::placeholder {
      color: black;
      font-weight: lighter;
    }
  `}
`
